import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import { useTranslation } from "react-i18next";
import Layout from "../../../components/Layout";
import VaadPageContent from "../../../components/Pages/Vaadim/SinglePage";
import { useParams } from "react-router";
import { useVaadTabs } from "../../../components/Pages/Vaadim/SinglePage/VaadTabs/context";

const { displayName } = config;

export default function VaadSinglePage(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Vaad Single Page`;
  }, []);

  return (
    <Layout>
      <VaadPageContent />
    </Layout>
  );
}
